<template>
  <div class="page page-with-bg login-page">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Create your profile</h1>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>
          <div class="row m-0">
            <v-form-group 
              :validator="$v.profile.firstName"
              label="First Name"
              class="col-6"
            >
              <b-form-input 
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                v-model="profile.firstName"
                placeholder="First Name" 
              />
            </v-form-group>
            <v-form-group 
              :validator="$v.profile.lastName"
              label="Last Name"
              class="col-6"
            >
              <b-form-input 
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
                v-model="profile.lastName"
                placeholder="Last Name" 
              />
            </v-form-group>
            <v-form-group :validator="$v.profile.phoneNumber"
                          label="Phone Number"
                          class="col-12">
              <form-input-formatted type="phone" 
                                    id="phone" 
                                    v-model="profile.phoneNumber" 
                                    placeholder="Phone Number" />
            </v-form-group>
            <b-form-group class="col-12">
              <b-card>
                <div class="row">
                  <div class="col-6">Administrator</div>
                  <div class="col text-dark">{{ profile.inviter }}</div>
                </div>
              </b-card>
            </b-form-group>
          </div>
          <b-form-group class="form-buttons">
            <b-button 
              size="lg" 
              variant="success" 
              type="submit"
            >
              Save &amp; Continue
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";
  import adminService from "services/admin-service";

  export default {
    mixins: [formMixin],

    props: {
      userId: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      },
      password: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        profile: null
      };
    },

    validations: {
      profile: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        phoneNumber: {
          required
        }
      }
    },

    async mounted() {
      const profile = await adminService.getByUserId(this.userId);

      this.profile = {
        ...profile,
        userId: this.userId,
        token: this.token,
        password: this.password
      };
    },

    methods: {
      async onSubmit() {
        await adminService.createProfile(this.profile);
        this.$router.push({ name: 'default' });
      },
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/heart.png');
  }
</style>